import { toast } from "sonner";
import { Tooltip, TooltipTrigger, TooltipContent } from "../../ui/tooltip";

// Chip that greys out with a tooltip (hover) or toast (tap) when invalid.
export function OptChip({ active, reason, onClick, testid, children }) {
  const disabled = Boolean(reason);
  const btn = (
    <button
      type="button"
      aria-pressed={active}
      aria-disabled={disabled}
      onClick={() => (disabled ? toast.info(reason) : onClick())}
      className={`px-2 py-1 text-[11px] inline-flex items-center gap-1 rounded border transition-colors duration-150 ${
        active
          ? "bg-[hsl(var(--primary))] text-white border-[hsl(var(--primary))]"
          : "hairline text-muted-foreground hover:text-foreground"
      } ${disabled ? "opacity-40 cursor-not-allowed" : ""}`}
      data-testid={testid}
      data-disabled={disabled ? "true" : "false"}
    >
      {children}
    </button>
  );
  if (!disabled) return btn;
  return (
    <Tooltip>
      <TooltipTrigger asChild>{btn}</TooltipTrigger>
      <TooltipContent className="max-w-[240px]">{reason}</TooltipContent>
    </Tooltip>
  );
}

export function ChipGroup({ label, children, testid }) {
  return (
    <div className="min-w-0" data-testid={testid}>
      <div className="eyebrow text-[9px] mb-1">{label}</div>
      <div className="flex flex-wrap gap-1">{children}</div>
    </div>
  );
}
